// This default locale is used when no currency code is provided or when the currency is not found in the mapping.
export const DEFAULT_CURRENCY_LOCALE = 'en-US';

// These locales work well with Intl.NumberFormat.
// Override edge cases (e.g., multilingual countries, shared currencies).
// Map of currency codes to their representative locales, temporary solution
export const currencyLocaleMap: Record<string, string> = {
  AED: DEFAULT_CURRENCY_LOCALE, // 'ar-AE', // Defaulting to en-US due to non-numbering system issue
  AFN: DEFAULT_CURRENCY_LOCALE, // 'fa-AF', // Defaulting to en-US due to non-numbering system issue
  ALL: 'sq-AL',
  AMD: 'hy-AM',
  ANG: 'nl-CW',
  AOA: 'pt-AO',
  ARS: 'es-AR',
  AUD: 'en-AU',
  AWG: 'nl-AW',
  AZN: 'az-AZ',
  BAM: 'bs-BA',
  BBD: 'en-BB',
  BDT: DEFAULT_CURRENCY_LOCALE, // 'bn-BD', // Defaulting to en-US due to non-numbering system issue
  BGN: 'bg-BG',
  BHD: DEFAULT_CURRENCY_LOCALE, // 'ar-BH', // Defaulting to en-US due to non-numbering system issue
  BIF: 'fr-BI',
  BMD: 'en-BM',
  BND: 'ms-BN',
  BOB: 'es-BO',
  BRL: 'pt-BR',
  BSD: 'en-BS',
  BTN: DEFAULT_CURRENCY_LOCALE, // 'dz-BT', // Defaulting to en-US due to non-numbering system issue
  BWP: 'en-BW',
  BYN: 'be-BY',
  BZD: 'en-BZ',
  CAD: 'en-CA',
  CDF: 'fr-CD',
  CHF: 'de-CH',
  CLP: 'es-CL',
  CNY: 'zh-CN',
  COP: 'es-CO',
  CRC: 'es-CR',
  CUP: 'es-CU',
  CVE: 'pt-CV',
  CZK: 'cs-CZ',
  DJF: 'fr-DJ',
  DKK: 'da-DK',
  DOP: 'es-DO',
  DZD: DEFAULT_CURRENCY_LOCALE, // 'ar-DZ', // Defaulting to en-US due to non-numbering system issue
  EGP: DEFAULT_CURRENCY_LOCALE, // 'ar-EG', // Defaulting to en-US due to non-numbering system issue
  ERN: 'ti-ER',
  ETB: 'am-ET',
  EUR: 'de-DE', // Or 'fr-FR', 'es-ES', etc. as many countries use EUR
  FJD: 'en-FJ',
  FKP: 'en-FK',
  GBP: 'en-GB',
  GEL: 'ka-GE',
  GHS: 'en-GH',
  GIP: 'en-GI',
  GMD: 'en-GM',
  GNF: 'fr-GN',
  GTQ: 'es-GT',
  GYD: 'en-GY',
  HKD: 'zh-HK',
  HNL: 'es-HN',
  HTG: 'fr-HT',
  HUF: 'hu-HU',
  IDR: 'id-ID',
  ILS: DEFAULT_CURRENCY_LOCALE, // 'he-IL', // Defaulting to en-US due to non-numbering system issue
  INR: 'en-IN',
  IQD: DEFAULT_CURRENCY_LOCALE, // 'ar-IQ', // Defaulting to en-US due to non-numbering system issue
  IRR: DEFAULT_CURRENCY_LOCALE, // 'fa-IR', // Defaulting to en-US due to non-numbering system issue
  ISK: 'is-IS',
  JMD: 'en-JM',
  JOD: DEFAULT_CURRENCY_LOCALE, // 'ar-JO', // Defaulting to en-US due to non-numbering system issue
  JPY: 'ja-JP',
  KES: 'en-KE',
  KGS: 'ky-KG',
  KHR: 'km-KH',
  KMF: 'fr-KM',
  KRW: 'ko-KR',
  KWD: DEFAULT_CURRENCY_LOCALE, // 'ar-KW', // Defaulting to en-US due to non-numbering system issue
  KYD: 'en-KY',
  KZT: 'kk-KZ',
  LAK: 'lo-LA',
  LBP: DEFAULT_CURRENCY_LOCALE, // 'ar-LB', // Defaulting to en-US due to non-numbering system issue
  LKR: 'si-LK',
  LRD: 'en-LR',
  LSL: 'en-LS',
  LYD: DEFAULT_CURRENCY_LOCALE, // 'ar-LY', // Defaulting to en-US due to non-numbering system issue
  MAD: DEFAULT_CURRENCY_LOCALE, // 'ar-MA', // Defaulting to en-US due to non-numbering system issue
  MDL: 'ro-MD',
  MGA: 'fr-MG',
  MKD: 'mk-MK',
  MMK: DEFAULT_CURRENCY_LOCALE, // 'my-MM', // Defaulting to en-US due to non-numbering system issue
  MNT: 'mn-MN',
  MOP: 'zh-MO',
  MRU: DEFAULT_CURRENCY_LOCALE, // 'ar-MR', // Defaulting to en-US due to non-numbering system issue
  MUR: 'en-MU',
  MVR: 'dv-MV',
  MWK: 'en-MW',
  MXN: 'es-MX',
  MYR: 'ms-MY',
  MZN: 'pt-MZ',
  NAD: 'en-NA',
  NGN: 'en-NG',
  NIO: 'es-NI',
  NOK: 'nb-NO',
  NPR: DEFAULT_CURRENCY_LOCALE, // 'ne-NP', // Defaulting to en-US due to non-numbering system issue
  NZD: 'en-NZ',
  OMR: DEFAULT_CURRENCY_LOCALE, // 'ar-OM', // Defaulting to en-US due to non-numbering system issue
  PAB: 'es-PA',
  PEN: 'es-PE',
  PGK: 'en-PG',
  PHP: 'en-PH',
  PKR: 'en-PK',
  PLN: 'pl-PL',
  PYG: 'es-PY',
  QAR: DEFAULT_CURRENCY_LOCALE, // 'ar-QA', // Defaulting to en-US due to non-numbering system issue
  RON: 'ro-RO',
  RSD: 'sr-RS',
  RUB: 'ru-RU',
  RWF: 'rw-RW',
  SAR: DEFAULT_CURRENCY_LOCALE, // 'ar-SA', // Defaulting to en-US due to non-numbering system issue
  SBD: 'en-SB',
  SCR: 'en-SC',
  SDG: DEFAULT_CURRENCY_LOCALE, // 'ar-SD', // Defaulting to en-US due to non-numbering system issue
  SEK: 'sv-SE',
  SGD: 'en-SG',
  SHP: 'en-SH',
  SLE: 'en-SL',
  SOS: 'so-SO',
  SRD: 'nl-SR',
  SSP: 'en-SS',
  STN: 'pt-ST',
  SYP: DEFAULT_CURRENCY_LOCALE, // 'ar-SY', // Defaulting to en-US due to non-numbering system issue
  SZL: 'en-SZ',
  THB: 'th-TH',
  TJS: 'tg-TJ',
  TMT: 'tk-TM',
  TND: DEFAULT_CURRENCY_LOCALE, // 'ar-TN', // Defaulting to en-US due to non-numbering system issue
  TOP: 'en-TO',
  TRY: 'tr-TR',
  TTD: 'en-TT',
  TWD: 'zh-TW',
  TZS: 'sw-TZ',
  UAH: 'uk-UA',
  UGX: 'en-UG',
  UYU: 'es-UY',
  UZS: 'uz-UZ',
  VES: 'es-VE',
  VND: 'vi-VN',
  VUV: 'en-VU',
  WST: 'en-WS',
  XAF: 'fr-CM',
  XCD: 'en-AG',
  XOF: 'fr-SN',
  XPF: 'fr-NC',
  YER: DEFAULT_CURRENCY_LOCALE, // 'ar-YE', // Defaulting to en-US due to non-numbering system issue // Defaulting to en-US due to non-numbering system issue
  ZAR: 'en-ZA',
  ZMW: 'en-ZM',
  ZWG: 'en-ZW',
  // Add other currencies and their default/representative locales as needed
};

export const getLocaleFromCurrency = (currencyCode?: string): string => {
  if (!currencyCode?.length) return DEFAULT_CURRENCY_LOCALE;
  const normalizedCode = currencyCode.toUpperCase();
  const locale = currencyLocaleMap[normalizedCode];

  if (!locale?.length) return DEFAULT_CURRENCY_LOCALE;

  return locale;
};
